/**
 * @flow
 * @author: Vamsi Tallam
 * */

/* eslint-disable no-confusing-arrow */

import styled from 'react-emotion'
import { Creatable } from 'react-select'

import { notMobile, mobile, tablet } from '../../../utils/mixins'
import bookNowConstants from '../../../constants/bookNowFormConstants'
import Colors from '../../../themes/Colors'
import {
  BaseDinBold,
  Typo18PumpkinOrangeDI,
  Typo13PumpkinOrangeDR,
  Typo16WhiteTwo80DR,
  Typo24PumpkinOrangeDI,
  Typo24WhiteTwoDI
} from '../../../themes/Fonts/Din2014'

import InputDiv from '../Input'
import { ErrorText } from '../Input/styledComponents'

import ReactSelectInput from './ReactSelectInput'

export const ApplyForFormSection = styled('div')`
  width: auto;
  display: flex;
  flex-direction: column;
  ${notMobile} {
    margin-left: auto;
    width: 555px;
    margin-right: auto;
  }
  ${mobile} {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Heading = styled(Typo18PumpkinOrangeDI)`
  line-height: 1.56;
  letter-spacing: 0.3px;
  padding-bottom: 1.25em;
  padding-top: 2.5em;
  margin-left: 8px;
  ${mobile} {
    margin-left: 0;
  }
`

export const FormContainer = styled('form')`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  justify-content: center;
  ${mobile} {
    flex-direction: column;
    flex-wrap: nowrap;
    min-height: 460px;
    padding-bottom: 120px;
  }
  ${tablet} {
    padding-bottom: 130px;
  }
  padding-bottom: 80px;
`
export const InputComponent = styled(InputDiv)`
  width: ${props => (props.inputType ? '521px' : '253px')};
  background-color: ${Colors.black20};
  position: relative;
  margin-right: 1.071em;
  ${mobile} {
    margin-right: 0em;
    width: 100%;
  }
`
export const TextAreaComponent = styled(InputDiv)`
  width: ${props => (props.inputType ? '521px' : '253px')};
  background-color: ${Colors.black20};
  height: 80px;
  position: relative;
  margin-right: 1.071em;

  ${mobile} {
    margin-right: 0em;
    width: 100%;
  }
`
export const EmptyInputComponent = styled('div')`
  width: 253px;
  visibility: hidden;
  margin-right: 1.071em;
`
export const RadioButtonComponent = styled('input')`
  width: 24px;
  height: 24px;
  background: ${Colors.whiteTwo80};
`
export const LocationInputComponent = styled('input')`
  height: 38px;
  background-color: ${Colors.black20};
  margin-right: 15px;
  ${mobile} {
    margin-right: 0px;
    width: 100%;
  }
`

export const ButtonWrapper = styled('div')`
  display: flex;
  justify-content: center;
`

export const ButtonText = styled(Typo13PumpkinOrangeDR)`
  height: 2.769em;
  border: solid 1px ${Colors.pumpkinOrange};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 10px 25px 9px 25px;
  :hover {
    color: ${Colors.whiteTwo};
    background-color: ${Colors.pumpkinOrange};
  }
`
export const Button = styled(BaseDinBold)`
  border: none;
  background: none;
  outline: none;
  height: 2.769em;
  border: solid 1px ${Colors.pumpkinOrange};
  font-size: 14px;
  line-height: 1.54;
  letter-spacing: 0.2px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0.769em 1.923em 0.769em 1.923em;
  line-height: normal;
  color: ${Colors.white};
  background-color: ${Colors.pumpkinOrange};

  ${mobile} {
    justify-content: center;
    display: flex;
  }
`

export const SuccessContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
`

export const SuccessText = styled('div')`
  opacity: 0.8;
  margin-top: 0.313em;
  margin-bottom: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  visibility: ${props => (props.submitted ? 'visible' : 'hidden')};
  ${mobile} {
    width: 90%;
  }
`
export const PrimaryThankYouText = styled(Typo24PumpkinOrangeDI)`
  margin-bottom: 20px;
  text-align: center;
  font-size: 26px;
  ${mobile} {
    font-size: 22px;
  }
`
export const SecondaryThankYouText = styled(Typo24WhiteTwoDI)`
  text-align: center;
  ${mobile} {
    font-size: 22px;
  }
`

export const LocationWrapper = styled('div')`
  position: relative;
`

/**
    TODO: - need to get style guide(color naming) from upendra, as he asked to get this styles from maps.google.com
    * */

export const PlacesSuggestionContainer = styled('div')`
  font-family: din-2014;
  position: absolute;
  background-color: ${Colors.white};
  border-radius: 0 0 2px 2px;
  box-shadow: 0 2px 4px ${Colors.black20};
  font-size: 15px;
  z-index: 2;
  width: ${props => props.suggestionsContainerWidth};
  top: 2.533em;
  ${mobile} {
    width: 100%;
  }
`
export const SuggestionContainer = styled('div')`
  background-color: ${props =>
    props.active === bookNowConstants.ACTIVE ? `${Colors.black6}` : null};
`
export const SuggestionInnerContainer = styled('div')`
  font-family: din-2014;
  color: #8c8c8c;
  font-size: 12px;
  line-height: 2em;
  min-height: 2em;
  padding-top: 0.5em;
  padding-bottom: 0.583em;
  border-top: 1px solid #e6e6e6;
  cursor: default;
  text-align: left;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  :hover {
    background-color: ${Colors.black6};
  }
  :active {
    background-color: ${Colors.black6};
  }
  :focus {
    background-color: ${Colors.black6};
  }
`
export const SuggestionContainerMainText = styled('span')`
  font-family: din-2014;
  color: #000;
  font-weight: 500;
  font-size: 13px;
  padding-left: 1.154em;
  padding-right: 0.385em;
`
export const SuggestionContainerSecondaryText = styled('span')`
  font-family: din-2014;
  color: #8c8c8c;
  font-size: 12px;
  line-height: 2em;
`
export const Loading = styled('span')`
  color: ${Colors.white};
`

export const OccupationSelectInput = styled(ReactSelectInput)`
  width: ${props => (props.inputType ? '521px' : '253px')};
  background-color: ${Colors.black20};
  position: relative;
  margin-right: 1.071em;
  ${mobile} {
    margin-right: 0em;
    width: 100%;
  }
`
export const EmployeeeSelectInput = styled(ReactSelectInput)`
  width: ${props => (props.inputType ? '521px' : '253px')};
  background-color: ${Colors.black20};
  position: relative;
  margin-right: 1.071em;
  ${mobile} {
    margin-right: 0em;
    width: 100%;
  }
`
export const AgeSelectInput = styled(ReactSelectInput)`
  width: ${props => (props.inputType ? '521px' : '253px')};
  background-color: ${Colors.black20};
  position: relative;
  margin-right: 1.071em;
  ${mobile} {
    margin-right: 0em;
    width: 100%;
  }
`
export const HaveYouExperienceIBCricketInput = styled(AgeSelectInput)`
  width: 521px;
`

export const WhichOpportunityAreYouInterestedInput= styled(AgeSelectInput)`
width: 521px;
`

export const DoYouHaveSpaceAvailableForSetupField = styled(
  HaveYouExperienceIBCricketInput
)``

export const BusinessSelectInput = styled(ReactSelectInput)`
  width: ${props => (props.inputType ? '521px' : '253px')};
  background-color: ${Colors.black20};
  position: relative;
  margin-right: 1.071em;
  ${mobile} {
    margin-right: 0em;
    width: 100%;
  }
`

export const ReactSelect = styled(Creatable)`
  border: ${props =>
    props.displayError
      ? `1px solid ${Colors.dullRed}`
      : `1px solid ${Colors.whiteTwo30}`};
`

export const SelectOption = styled(SuggestionInnerContainer)``

export const ReactSelectError = styled(ErrorText)`
  visibility: ${props => (props.displayError ? 'visible' : 'hidden')};
`
export const RadioButtonContainer = styled('div')`
  display: flex;
  width: 100%;
  margin-bottom: 35px;
  margin-left: 2%;
  flex-direction: column;
  justify-content: flex-start;
  ${mobile} {
    justify-content: space-between;
    ${'' /* margin-bottom: 120px; */} align-items: flex-start;
  }
`
export const RadioButtonHeading = styled(Typo16WhiteTwo80DR)`
  letter-spacing: 0.3px;
  padding-bottom: 15px;
  ${mobile} {
    padding-bottom: 0px;
  }
`

export const PreferredLocationHeading = styled(RadioButtonHeading)`
  margin-left: 2%;
  width: 100%;
  ${mobile} {
    margin-bottom: 20px;
  }
`
export const WhyAreYouInterestedHeading = styled(RadioButtonHeading)`
  margin-left: 2%;
  width: 100%;
  ${mobile} {
    margin-bottom: 20px;
  }
`

export const RadioButtonsWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 35%;
  ${mobile} {
    align-items: center;
  }
`
export const RadioButtonLabel = styled(Typo16WhiteTwo80DR)`
  letter-spacing: 0.3px;
  ${'' /* padding-top: 4px; */} margin-left: 35px;
`

export const ResponsiveContainer = styled('div')`
  width: 1124px;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: 320px) and (max-width: 425px) {
    width: 93.75%;
  }
  @media (min-width: 426px) and (max-width: 767px) {
    width: 90%;
  }
  @media (min-width: 768px) and (max-width: 1123px) {
    width: 90%;
  }
  @media (min-width: 1124px) and (max-width: 1250px) {
    width: 90%;
  }
`



// WEBPACK FOOTER //
// ./src/components/ApplyFranchiseComponent/ApplyForFranchiseForm/styledComponents.js